import React from "react";
import { Link } from "react-router-dom";

export default function SecondPage() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>This is the Second Page!</h1>
      <Link to="/">
        <button style={{ fontSize: "20px", padding: "15px 30px", marginTop: "20px" }}>
          Back to Landing Page
        </button>
      </Link>
    </div>
  );
}
